import { GenericSlot, GenericSlotFactory } from 'base/components/GenericSlot';
import { Dialog as StandaloneDialog } from '@/components/Dialog';
import { PostActionDialogTheme } from '@/components/PostActionDialog/theme';

const $ = GenericSlotFactory({ theme: PostActionDialogTheme });

const Base = $({ as: 'div', slot: 'base' });
const Dialog = GenericSlot({ as: StandaloneDialog, theme: PostActionDialogTheme.Dialog });

export const PostActionDialog = Object.assign(Base, { Dialog });
